module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/2_86417455023b6c96516041ffdfe448e5.png";